import { Injectable, Injector } from '@angular/core';
import { from, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class MercadoPagoService {

    constructor(private window: Window) { }

    iniciarServico() {
        this.window["Mercadopago"].setPublishableKey(environment.mercadoPagoApiKey);
    }

    obterMetodoPagamento(numeroCartao: string) {
        return new Observable((x) => {
            this.window["Mercadopago"].getPaymentMethod({
                "bin": numeroCartao.substring(0, 6)
            }, paymentMethod);

            function paymentMethod(status, response) {
                if (status == 200) {
                    x.next(response[0].id);
                    x.complete();
                }
                abp.ui.clearBusy();
                x.next(null);
                x.complete();
            }
        })
    }

    obterTokenPagamento(numeroCartao: string, mesExpiracao: string, anoExpiracao: string, numeroCpf: string, nome: string, ccv: string) {
        return new Observable((x) => {
            this.window["Mercadopago"].clearSession();
            this.window["Mercadopago"].createToken({
                cardholderName: nome,
                docType: 'CPF',
                docNumber: numeroCpf,
                cardExpirationMonth: mesExpiracao,
                cardExpirationYear: anoExpiracao,
                cardNumber: numeroCartao,
                securityCode: ccv
            }, obterCardToken);

            function obterCardToken(status, response) {
                if (status == 200) {
                    x.next(response.id);
                    x.complete();
                    return;
                }

                abp.ui.clearBusy();
                abp.message.error('Dados do cartão inválidos.');
                x.next(null);
                x.complete();
            }
        })
    }
}